import { type FC, type PropsWithChildren } from 'react';

import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';
import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { rechargeOneDiceGameEnergy } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { RecoverDiceEnergyContext } from './context';

const RecoverDiceEnergyProvider: FC<PropsWithChildren> = ({ children }) => {
  const vip = useCheckVIPstatus();
  const energyRecoveryTime = useAppSelector(
    (state) => state.diceGame.user?.energyRecoveryTime,
  );
  const dispatch = useAppDispatch();
  const recoverOneEnergyAfterTimeEnds = (seconds: number): void => {
    if (seconds === 0 && !!energyRecoveryTime) {
      dispatch(rechargeOneDiceGameEnergy({ vip: !!vip }));
    }
  };
  const currentTimeToRecoverOneEnergy = useCountDownTimer(
    energyRecoveryTime || 0,
    recoverOneEnergyAfterTimeEnds,
  );

  return (
    <RecoverDiceEnergyContext.Provider
      value={{ currentTimeToRecoverOneEnergy }}
    >
      {children}
    </RecoverDiceEnergyContext.Provider>
  );
};

export { RecoverDiceEnergyProvider };
